import React from 'react'
import cx from 'classnames'

import Text, { TextProps } from 'components/_new/typography/Text/Text'

import s from './CheckboxView.scss'


export type CheckboxViewProps = {
  className?: string
  label?: string | ReactIntlMessage
  labelProps?: TextProps
  value: boolean
  readOnly?: boolean
  dataTestId?: string
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void
}

const CheckboxView: React.FunctionComponent<CheckboxViewProps> = (props) => {
  const { children, className, label, labelProps = {}, value, readOnly, dataTestId, onChange } = props
  const { className: labelClassName, ...restLabelProps } = labelProps as TextProps

  return (
    <label
      className={cx(s.container, className)}
      data-testid={dataTestId}
    >
      <input
        className={s.input}
        type="checkbox"
        checked={value}
        readOnly={readOnly}
        onChange={readOnly ? null : onChange}
      />
      <span className={s.checkbox} />
      {
        Boolean(label || children) && (
          <Text
            className={cx(s.label, labelClassName)}
            message={label}
            html
            {...restLabelProps}
          >
            {children}
          </Text>
        )
      }
    </label>
  )
}


export default CheckboxView
